module.exports = __webpack_public_path__ + "static/media/cutsglare_spanish_00123.7a86d4f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/es/cutsglare_spanish_00123.png
// module id = 1451
// module chunks = 0